import React from "react";
 
const WarningIcon = () => (
    <svg width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 1.5C17.799 1.5 22.5 6.20105 22.5 12C22.5 17.799 17.799 22.5 12 22.5C6.20105 22.5 1.5 17.799 1.5 12C1.5 6.20105 6.20105 1.5 12 1.5ZM12.9 7.2H11.1V13.6904H12.9V7.2ZM11.1 15.3V17.1H12.9V15.3H11.1Z" fill="#FFA023"/>
    </svg>
);
 
export default WarningIcon;